import React from "react";
import { ExamResultsStyles } from "./styles.js";
import BreadcrumbBox from "../../components/common/Breadcrumb.jsx";
import { useLanguageDetector } from "../../hooks/useLanguageDetector";
import EnglishData from "../../data/scholarship-exam/en.json";
import RussianData from "../../data/scholarship-exam/ru.json";
import UzbekData from "../../data/scholarship-exam/uz.json";
import { Container } from "react-bootstrap";
import { colors } from "../../components/common/element/elements.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import Heading from "../../components/shared/Heading.jsx";

const ScholarshipExamResults = () => {
  const [allData] = useLanguageDetector(EnglishData, RussianData, UzbekData);
  const data = allData.results;

  return (
    <>
      <BreadcrumbBox
        title={data?.title}
        image="/assets/images/scholarship_exam.webp"
        centerTitle={true}
        registerButton={false}
        registerLink="/scholarship-exam-results"
      />
      <ExamResultsStyles>
        <Container>
          <div className="info">
            <Heading
              tag="h4"
              className="strategy-title"
              title={data?.info?.title}
            />
            <p>
              {data?.info?.subtitle1?.preBold}
              <strong>{data?.info?.subtitle1?.bold}</strong>
              {data?.info?.subtitle1?.postBold}
            </p>
            <ul className="list-unstyled info-list">
              {data?.info?.list.map((item, index) => (
                <li className="d-flex mb-3 item" key={index}>
                  <div>
                    <Icon
                      icon="ph:paper-plane-right-duotone"
                      fontSize={20}
                      color={colors.bg1}
                    />
                  </div>
                  <p className="ps-3">
                    <span>{item?.title}</span> -{" "}
                    <a href={item?.href} target="_blank" rel="noreferrer">
                      {item?.link}
                    </a>
                  </p>
                </li>
              ))}
            </ul>
            <p>{data?.info?.subtitle2}</p>
          </div>
          <div className="marking">
            <Heading
              tag="h4"
              className="strategy-title"
              title={data?.marking?.title}
            />
            <p>{data?.marking?.subtitle1}</p>
            <ul className="list-unstyled marking-list">
              {data?.marking?.list.map((item, index) => (
                <li className="d-flex mb-3 item" key={index}>
                  <div>
                    <Icon
                      icon="ph:paper-plane-right-duotone"
                      fontSize={20}
                      color={colors.bg1}
                    />
                  </div>
                  <p className="ps-3">
                    <a href={item?.link} target="_blank" rel="noreferrer">
                      {item?.title}
                    </a>
                  </p>
                </li>
              ))}
            </ul>
            <p className="contact">
              <span>{data?.marking?.subtitle2?.preContact}</span>
              <a href={`mailto:${data?.marking?.subtitle2?.email}`}>
                {data?.marking?.subtitle2?.email}
              </a>

              <span>{data?.marking?.subtitle2?.or}</span>
              <a href={`tel:${data?.marking?.subtitle2?.phone}`}>
                {data?.marking?.subtitle2?.phone}
              </a>
            </p>
          </div>
        </Container>
      </ExamResultsStyles>
    </>
  );
};

export default ScholarshipExamResults;
